import React, { useState, useEffect, useMemo, useRef, useLayoutEffect } from "react";
import ReactMarkdown from 'react-markdown';
import Fuse from "fuse.js";
import axios from 'axios';
import UploadWrapper from './UploadWrapper.js';
import CreateClient from './CreateClient.js';
import CreateOrder from './CreateOrder.js';
import { useAuthContext } from '../contexts/AuthContext.js';
import { useNewChatContext } from '../contexts/NewChatContext.js';
import CreateMeeting from "./CreateMeeting.js";
import AILoadingText from "./AILoadingText.js";
import { useUploadContext } from "../contexts/UploadContext.js";
import MessageAttachments from "./MessageAttachments.js";
import { api } from "../apiClient.js";
import { linkify } from "../utils/linkify.js";

const ConversationForm = ({
  isSidebarVisible, setIsSidebarVisible,
  selectedConversation = null,
  uploadedFiles, setUploadedFiles
}) => {
  const { newChatInput, setNewChatInput, newChatId, setNewChatId } = useNewChatContext();
  const { AuthData, updateAuthData, user, setUser } = useAuthContext();
  const [selectedComponent, setSelectedComponent] = useState(null); // 管理顯示的元件
  const [input, setInput] = useState("");
  const [component, setComponent] = useState(null);
  const [azureOpenAIResponse, setAzureOpenAIResponse] = useState([]);
  const [flaskLoading, setFlaskLoading] = useState(null);
  const textareaRef = useRef(null);

  // ⭐ 自動調整高度
  useLayoutEffect(() => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = "auto";               // 先重置
    el.style.height = `${el.scrollHeight}px`; // 再撐高 // 內容實際高度
  }, [input]);

  const handleKeyDown = (e) => {
    console.log("keydown event:", e);
    if (e.isComposing || e.keyCode === 229) return;
    // Enter 送出、Shift+Enter 換行
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const options = {
    includeScore: true,
    threshold: 0.4,
  };

  const keywords = {
    "新增客戶": ["新增客戶", "創建客戶", "建立客戶", "Client", "dk4cj4"],
    "新增訂單": ["新增訂單", "創建訂單", "建立訂單", "Order", "2/u420 "],
    "上傳": ["上傳", "檔案", "提交檔案", "傳檔", "Upload", "g;4tj06"],
    "新增會議": ["新增會議", "創建會議", "建立會議", "Meeting", "cjo4u4"],
    // "檔名資料": ["檔案", "文件", "查找檔案", "搜尋檔名"],
  };

  // 監聽 component 的變化，自動顯示/隱藏側邊欄
  useEffect(() => {
    if (component != null) {
      setIsSidebarVisible(true); // 顯示側邊欄
    } else {
      setIsSidebarVisible(false); // 隱藏側邊欄
    }
  }, [component]); // 當 input 改變時執行

  useEffect(() => {
    console.log(azureOpenAIResponse);
  }, [azureOpenAIResponse])

  console.log("selectedConversation:", selectedConversation)
  const [records, setRecords] = useState([]);
  // const id = useMemo(() => newChatId ?? selectedConversation?.id, [newChatId, selectedConversation]);
  const id = selectedConversation?.id || newChatId;
  console.log("newChatId:", newChatId)
  console.log("id:", id)

  // 在頁面載入時發送 API 請求
  useEffect(() => {
    if (!id) return;   // 沒有 id 就不要呼叫 API
    console.log("✅ useEffect RUN with id:", id);

    fetch(`http://localhost:5000/api/conversations/${id}/messages`)
      .then(response => response.json())
      .then(data => {
        console.log("conversations messages:", data)
        setRecords(data)
      })
      .catch(error => console.error('Error fetching records:', error));
  }, [id]);

  useEffect(() => {
    console.log("records.messages:", records.messages);
  }, [records])

  const { uploadAttachments, updateUploadAttachments, setUploadAttachments } = useUploadContext();

  const hasAutoSentRef = useRef(false);
  useEffect(() => {
    setUploadAttachments([]);
    if (id && newChatInput && !hasAutoSentRef.current) {
      handleSendMessage(newChatInput);
      hasAutoSentRef.current = true;
    }
  }, [id, newChatInput]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = input.trim();
    if (!trimmed) return alert("請輸入文字！");
    handleSendMessage(trimmed);
  };

  const handleSendMessage = async (message) => {
    // setAzureOpenAIResponse((prev) => [
    //   ...prev,
    //   { role: 'user', content: message },
    // ])

    setFlaskLoading(true);
    console.log(message);
    // setAzureOpenAIResponse("");

    try {
      // ✅ 等待上傳並取得檔案網址（假設它會 return）
      const uploadResponse = await handleUploadAttachments(message); // 這裡要回傳 response

      const filesForMessage = (uploadResponse?.data || []).map((file, idx) => ({
        id: file.id ?? idx,                  // 如果後端沒 id 就用 index
        file_name: file.file_name,
        file_url: file.view_url,             // 給預覽 / 下載用
        file_type: file.file_type,
        file_size: file.file_size,
      }));

      const urls = uploadResponse.data.map(file => file.view_url);
      setFileUrls(urls);

      // 1. 傳遞文字給 AI 解析
      // const response = await axios.post("http://localhost:5000/api/chat", {
      const response = await api.post("/api/chat", {
        user_id: user.user_id,
        user_input: message,
        file_urls: urls,
        is_personal_conversation: true,
        conversation_id: newChatId || selectedConversation?.id,
      });
      setAzureOpenAIResponse((prev) => [
        ...prev,
        {
          role: "user",
          content: message,
          files: filesForMessage,    // ⭐ 這裡塞附件
        },
        { role: 'assistant', content: response.data.message }
      ])
      console.log(response);

      // updateConversationState(2, input)

    } catch (error) {
      console.error("Error communicating with the server:", error);
    } finally {
      console.log(flaskLoading);
      setFlaskLoading(false);
      setInput("");
    }
  };

  async function updateConversationState(conversationId, userInput) {
    const res = await fetch("/api/conversations/${conversationId}/state", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        conversation_id: conversationId,
        user_input: userInput,
      }),
    });

    if (!res.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await res.json();
    console.log("AI 回傳:", data);
    return data;
  }

  const handleChange = (e) => {
    const text = e.target.value;
    setInput(text);
    let matchedComponent = null;

    for (const [key, words] of Object.entries(keywords)) {
      const fuse = new Fuse(words, options);
      const result = fuse.search(text);
      if (result.length > 0) {
        if (key === "新增客戶") matchedComponent = <CreateClient />;
        else if (key === "新增訂單") matchedComponent = <CreateOrder />;
        else if (key === "上傳") matchedComponent = <UploadWrapper />;
        else if (key === "新增會議") matchedComponent = <CreateMeeting />;
        // else if (key === "檔名資料") {
        //   // 假設 fetchFileUrls 返回檔案列表，並更新到某個元件中
        //   matchedComponent = <div>檔名相關搜尋結果</div>;
        // }
        break;
      }
    }

    setComponent(matchedComponent);
  };


  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const [fileUrls, setFileUrls] = useState([]);

  // 上傳文件與數據
  const handleUploadAttachments = async (message) => {
    // e.preventDefault();

    // 從 uploadData.files 中獲取檔案名稱
    // const title = uploadData.files?.[0] || ""; // 獲取第一個檔案名稱，預設為空字串
    // // 收集所有表單數據
    // const fileData = {
    //   // title: uploadData.fileName[0], // 使用同步的檔案名稱
    //   access: selectedAccess,
    //   client: selectedClient,
    //   project: selectedProject,
    //   fileName: uploadData.fileName,
    //   file: uploadData.file,
    // };
    // console.log(fileData);
    // updateUploadData(fileData);

    // console.log("File Data to Update:", fileData); // 確認即將更新的資料

    if (!uploadAttachments || uploadAttachments.length === 0) {
      return { data: [] }; // 沒檔案就給空陣列，前面不會壞掉
    }
    console.log("uploadAttachments:", uploadAttachments); // 確認即將更新的資料

    const payload = new FormData();
    // 遍歷 uploadData 陣列，將每個檔案和元數據附加到 FormData
    uploadAttachments.forEach((attachment, index) => {
      // 將元數據轉為 JSON 字串
      payload.append(`metadata_${index}`, JSON.stringify({
        // access: data.access,
        // client: data.client,
        // case_no: "case_no",
        // case_name: data.case_name,
        // type: data.type,
        message_type: "conversation",
        id: id || 1,
        user_input: message,
        user_id: user?.user_id || 1,
        file_name: attachment.fileName,
        relative_path: attachment.file?.relativePath || attachment.fileName,  // ✅ 新增這行
        file_type: attachment.file?.type,
        file_size: attachment.file?.size
      }));
      console.log('file_type:', attachment.file?.type)
      // 附加檔案
      payload.append(`file_${index}`, attachment.file); // 檔案物件
    });
    // for (let pair of payload.entries()) {
    //   console.log(pair[0], pair[1]); // 驗證 payload
    // }

    try {
      console.log(payload);
      // setUploadStatus("上傳中...");
      // const response = await axios.post("http://127.0.0.1:5000/attachments-upload",
      const response = await api.post("/attachments-upload",
        payload,
        {
          headers: {
            // Authorization: `Bearer ${loginResponse.accessToken}`,
            "Content-Type": "multipart/form-data",
            // timeout: 300000  // 5 分鐘
          },
        }
      );
      console.log(response);
      // setUploadStatus("上傳完成！");
      return response;
      // // 更新 fileUrls 狀態
      // setFileUrls(response.data); // response.data 是一個包含字典的數組

    } catch (error) {
      console.error("上傳失敗:", error);
      // setUploadStatus("上傳失敗！");
    }


    // if (!file || !formData.title || !formData.description || !formData.keywords) {
    //   setUploadStatus("請填寫所有欄位並選擇文件！");
    //   return;
    // }

    // const payload = new FormData();
    // payload.append("file", file);
    // payload.append("title", formData.title);
    // payload.append("description", formData.description);
    // payload.append("keywords", formData.keywords);

    // try {
    //   setUploadStatus("上傳中...");
    //   const response = await axios.post("http://127.0.0.1:5000/upload", payload, {
    //     headers: { "Content-Type": "multipart/form-data" },
    //   });
    //   setUploadStatus(`上傳成功！文件 URL: ${response.data.url}`);
    // } catch (error) {
    //   console.error("上傳失敗:", error);
    //   setUploadStatus("上傳失敗！");
    // }
  };

  // // 模擬文件上傳
  // files.forEach((file) => {
  //   console.log(`Uploading file: ${file.name}`);
  // });

  const handleFileDrop = (files) => {
    // const newEntries = files.map((file) => ({
    //   fileName: file.name,
    //   file, // 將檔案物件存入
    //   access: "", // 初始為空，submit 時再更新
    //   client: "",
    //   project: "",
    // }));
    // updateUploadData(newEntries); // 將新檔案加入 context
    const newEntries = files.map((file) => ({
      fileName: file.name,
      file, // 儲存檔案物件
      // ...commonData, // 即時同步表單資料
    }));
    updateUploadAttachments(newEntries); // 更新 Context，覆蓋舊檔案
    console.log(uploadAttachments);
  };

  return (
    <div style={{ height: "100%", }}>
      {/* <br /> */}
      <div className='chat-log'>
        <AIReply records={records} />
        {azureOpenAIResponse &&
          azureOpenAIResponse.map((msg, index) => (
            <div
              key={index}
              className={`message-bubble ${msg.role === "user" ? "question" : "response"
                }`}
            >
              {/* <div
              key={index}
              className={`${msg.role === 'user' ? 'question' : ''
                }`}
            >
              <div
                className={`${msg.role === 'user'
                  ? ''
                  : 'response'
                  }`}
              > */}

              {/* ⭐ 這裡顯示附件（如果有） */}
              <MessageAttachments files={msg.files} />
              {/* <ReactMarkdown>{msg.content}</ReactMarkdown> */}
              {
                msg.role === 'user'
                  ? <p>{linkify(msg.content)}</p>
                  : <ReactMarkdown>{msg.content}</ReactMarkdown>
              }
              {/* </div> */}
            </div>
          )
          )}
        {flaskLoading ? <AILoadingText /> : ""}
        {/* 根據不同的回應顯示不同的內容 */}
      </div>

      <form className={`create-form ${isSidebarVisible ? 'sidebar-open' : ''}`} onSubmit={(e) => handleSubmit(e, input)}>
        <div className="message-area">
          {/* <input
        type="text"
        value={content}
        onChange={(e) => { setContent(e.target.value) }}
        placeholder="請輸入訊息"
        /> */}
          <div className="message-attachments">
            {uploadAttachments &&
              uploadAttachments.map((uploadAttachment) => {
                return (
                  <div className="message-attachment">
                    {uploadAttachment.fileName}
                  </div>
                )
              })
            }
          </div>
          <div className="message-row">
            {/* <button className="composer-btn" type="button">➕</button> */}
            <input
              type="file"
              multiple
              // webkitdirectory="true"
              // directory="true"
              onChange={(e) => handleFileDrop(Array.from(e.target.files))}
              style={{ display: "none" }}
              id="fileInput"
            />
            <label
              htmlFor="fileInput"
              className="composer-btn"
            >
              ➕
              {/* 選擇檔案
              <img src='./arrow04.png' style={{
                width: "20%",
              }}></img> */}
            </label>

            <textarea
              ref={textareaRef}
              type="text"
              value={input}
              rows={1}
              // onChange={(e) => setInput(e.target.value)}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              placeholder="Enter your message..."
            // className="chat-textarea"
            />

            <button type="submit">
              <img className="sent-message" src="./sent.png" alt="送出" />
            </button>
          </div>
        </div>
        <div className="toggle-area">
          {/* 固定在畫面右邊的按鈕 */}
          <button
            type="button" className="toggle-button" onClick={toggleSidebar}>
            {isSidebarVisible ? ">>" : "<<"}
          </button>
        </div>

      </form>

      {/* 可顯示/隱藏的右側區塊 */}
      <div className={`sidebar ${isSidebarVisible ? "visible" : "hidden"}`}>
        {/* {renderComponent()} */}
        {component}
      </div>

      {/* <div style={{ marginTop: "20px" }}>{selectedComponent}</div> */}
    </div>
  );
}

// function AIReply({ data, records }) {
//   return (
//     <>
//       {records?.messages?.map((msg, index) => (
//         <div
//           key={index}
//           className={`${msg.role === 'user' ? 'question' : ''
//             }`}
//         >
//           <div
//             className={`${msg.role === 'user'
//               ? ''
//               : 'response'
//               }`}
//           >
//             <ReactMarkdown>{msg.content}</ReactMarkdown>
//           </div>
//         </div>
//       )
//       )}
//     </>
//   )
// }


function AIReply({ records }) {
  function groupMessages(messages) {
    if (!Array.isArray(messages)) return [];

    const grouped = [];
    let last = null;

    messages.forEach((msg) => {
      const key =
        msg.created_at + "_" + msg.role + "_" + msg.sender_id;

      if (last && last.groupKey === key) {
        // 同一群 → 合併 files
        last.files = [...(last.files || []), ...(msg.files || [])];
      } else {
        // 開始新的一群
        last = {
          ...msg,
          files: [...(msg.files || [])],
          groupKey: key,
        };
        grouped.push(last);
      }
    });

    return grouped;
  }

  // records 有可能還沒載到，所以防呆一下
  const messages = records?.messages || [];
  const grouped = groupMessages(messages);

  return (
    <>
      {records?.messages?.map((msg, index) => (
        <div
          key={index}
          className={`message-bubble ${msg.role === "user" ? "question" : "response"
            }`}
        >
          <MessageAttachments files={msg.files} />
          {/* <ReactMarkdown>{msg.content}</ReactMarkdown> */}

          {
            msg.role === 'user'
              ? <p>{linkify(msg.content)}</p>
              : <ReactMarkdown>{msg.content}</ReactMarkdown>
          }
        </div>
      ))}
    </>
  )
}

export default ConversationForm;